$(document).ready(function(){
  
  $("#cartform select.quantity").on("change", function(){
    $("#cartform").submit();
  });

  $("#address_province").on("change", function(){
    $("#address_zip").focus();
  });

  $("#address_zip").on("keypress", function(e){
    if (e.keyCode == 13) {
      e.preventDefault();
      $(this).blur();
      $(".get-rates").trigger("click");
    }
  });

});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImage, mainImageDomEl) {
  jQuery(mainImageDomEl).attr('src', newImage.src);
};
